import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { TrendingUp, Cpu, Zap } from 'lucide-react';
export function InferenceShiftSlide() {
  return <SlideLayout slideNumber={5} totalSlides={20} title="The Paradigm Shift" data-id="element-325">
      <div className="w-full h-full flex flex-col md:flex-row gap-8" data-id="element-326">
        <div className="flex-1 flex flex-col justify-center" data-id="element-327">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="mb-7" data-id="element-328">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-lg font-medium mb-4" data-id="element-329">
              <TrendingUp size={20} data-id="element-330" />
              <span data-id="element-331">Market Trend 2025-2026</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight" data-id="element-332">
              From Training to{' '}
              <span className="text-brand-primary" data-id="element-333">Inference</span>
            </h2>
            <p className="text-2xl text-brand-muted leading-relaxed" data-id="element-334">
              As models mature, the workload shifts from massive training runs
              to continuous inference. This changes the hardware requirements
              completely.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="space-y-5" data-id="element-335">
            <div className="flex items-start gap-4" data-id="element-336">
              <div className="p-2.5 bg-brand-surface rounded-lg text-chip-asic shrink-0" data-id="element-337">
                <Cpu size={28} data-id="element-338" />
              </div>
              <div data-id="element-339">
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-340">
                  Efficiency Over Raw Power
                </h3>
                <p className="text-brand-muted text-xl" data-id="element-341">
                  Inference requires low latency and high efficiency per watt,
                  not just brute force throughput.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-342">
              <div className="p-2.5 bg-brand-surface rounded-lg text-chip-fpga shrink-0" data-id="element-343">
                <Zap size={28} data-id="element-344" />
              </div>
              <div data-id="element-345">
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-346">
                  Cost Sensitivity
                </h3>
                <p className="text-brand-muted text-xl" data-id="element-347">
                  Running models at scale is expensive. The $30k GPU economics
                  don't scale linearly for deployment.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="flex-1 flex items-center" data-id="element-348">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="bg-brand-surface border border-brand-border rounded-2xl p-10 text-center relative overflow-hidden w-full" data-id="element-349">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-chip-asic to-brand-primary" data-id="element-350" />
            <h3 className="text-brand-muted text-xl mb-3" data-id="element-351">
              Projected 2025 Inference Deployment Share
            </h3>
            <div className="text-8xl md:text-9xl font-mono font-bold text-white mb-2" data-id="element-352">
              37<span className="text-5xl text-brand-primary" data-id="element-353">%</span>
            </div>
            <p className="text-2xl text-brand-muted mb-6" data-id="element-354">
              Captured by ASICs & Specialized Hardware
            </p>
            <div className="text-lg text-brand-muted/60 italic" data-id="element-355">
              "Surpassing GPUs in efficiency even if not total revenue."
            </div>
          </motion.div>
        </div>
      </div>
    </SlideLayout>;
}